export default __webpack_public_path__ + "static/media/es-ga.fb5415e3.svg";